<mat-card class="mat-card mat-focus-indicator">
	<mat-card-title>
		<h2>{{roleData?.create ? 'Create' : 'Edit'}} Role</h2>
	</mat-card-title>
	<mat-card-subtitle>Here you can update the settings for your role.</mat-card-subtitle>

	<mat-card-content>

		<form [formGroup]="roleForm" *ngIf="roleForm">
			<div class="row">
				<div class="col-12 col-md-6">
					<div class="row">
						<mat-form-field class="col-12">
							<input type="text" [ngClass]="{ 'is-invalid': submitted && f.name.errors }" matInput
								placeholder="Role Name" formControlName="name">
						</mat-form-field>
						<div class="text-danger" *ngIf="f.name.errors && (f.name.dirty || f.name.touched) ">
							<div *ngIf="f.name.errors.required" padding>
								*Please enter a role name
							</div>
						</div>
					</div>

				</div>
			</div>

			<div class="row" *ngIf="features" formGroupName="features">
				<div class="col-md-2 col-12 additional-spacing" *ngFor="let feature of features">
					<h4><b>{{feature.name | titlecase}}</b></h4>

					<mat-slide-toggle *ngFor="let permission of feature.permissions" [formControlName]="permission.name">{{permission.name}}</mat-slide-toggle>
				</div>
			</div>
		</form>

		<button class="m-1" mat-raised-button color="primary" (click)="submit()">Submit</button>
		<button class="m-1"mat-stroked-button (click)="exitEdit()">Exit</button>
	</mat-card-content>
</mat-card>
